angular.module('webcomm').controller('CallEventController', ['$scope', '$log', 'timeFormattingService', function ($scope, $log, timeFormattingService) {
    $scope.timeSent = timeFormattingService.formatFeedDate($scope.feedEvent.clientTime);
}]);